<template>
    <div class="sl-order-form__line sl-order-form__line-no">
        <template v-for="side in ['right', 'left']" :key="side">
            <field-factory
                v-if="line[`${side}Parameter`]"
                :side="side"
                :index="index"
                :parameter="line[`${side}Parameter`]"
                @templated="$emit('templated', $event)"
            />
        </template>
    </div>
</template>

<script setup>
import FieldFactory from './FieldFactory.vue';

const props = defineProps({
    index:
    {
        type:     Number,
        required: true,
    },

    code:
    {
        type:     String,
        required: true,
    },

    line:
    {
        type:     Object,
        required: true,
    },
});

const emit = defineEmits(['templated']);
</script>

<style scoped>
@reference "#main.css";

.sl-order-form__line-no
{
    @apply hidden;
}
</style>
